import { useSkillsType } from "PFCore/hooks/use_skills_type";
import { Id } from "PFTypes/id";

export const useSkillsCustomTypeId = (): Id => useSkillsType()!.id;
